import { useEffect, useState } from 'react';
import type { MatchLiveViewers } from '@aiscoreboard/contracts';
import { fetchLiveViewers } from './api';

export function useLiveViewers(matchId: string | null): MatchLiveViewers | null {
  const [result, setResult] = useState<{ matchId: string; data: MatchLiveViewers } | null>(null);
  useEffect(() => {
    if (!matchId) return;
    const controller = new AbortController();
    let timer: ReturnType<typeof setTimeout>;
    const poll = async () => {
      try {
        const data = await fetchLiveViewers(matchId, controller.signal);
        if (!controller.signal.aborted) setResult({ matchId, data });
      } catch (error) {
        if (!controller.signal.aborted) {
          console.warn('[live-viewers] refresh failed', error);
          setResult({ matchId, data: { status: 'error', concurrentViewers: null, updatedAt: null } });
        }
      } finally {
        if (!controller.signal.aborted) timer = setTimeout(() => void poll(), 10_000);
      }
    };
    void poll();
    return () => { controller.abort(); clearTimeout(timer); };
  }, [matchId]);
  return result?.matchId === matchId ? result.data : null;
}
